module.exports = __webpack_public_path__ + "img/grizzly-not-found.580bccc.gif";